module.exports = __webpack_public_path__ + "img/ic-file.632075dd.svg";